import { createCtx } from '@shared/util/context';
import { ControlsActions, ControlsState } from '../types';

export const [useControlsState, ControlsStateProvider] = createCtx<ControlsState>();
export const [useControlsActions, ControlsActionsProvider] = createCtx<ControlsActions>();
